module.exports = __webpack_public_path__ + "img/37CDF956FB99616BA166DC17329BEFCA.37cdf956.svg";